export default __webpack_public_path__ + "bb47750e958e827810ccafaf2e7240ec.jpg";